import { Container } from "@mui/material";
import React, { FC, ReactNode } from "react";

type smContProps = {
  children: ReactNode;
};

const SmCont: FC<smContProps> = ({ children }: smContProps) => {
  return <Container maxWidth="sm">{children}</Container>;
};

export default SmCont;
